import { audienceSortStepNames } from "./utility/audienceSortStepNames";
import { sanitizeHtml } from "utils/sanitizeHtml";
import {
	changeCountry,
	eventMisfired,
	getAudienceSelection,
	individualGUID
} from "./utility/audienceSortApiHandlers";
import { LocationChangeCTA } from "./LocationChangeCTA";
import {
	AudienceSelectionProps,
	AudienceSplashModalSelectorData,
	CountryListDataProps,
	SectionAudienceType
} from "components/public-site/audience-sort/utility/audienceSortPropTypes";
import { AudienceSelectorList } from "./AudienceSelectorList";

type AudienceSelectorFromLinkEntryProps = {
	audienceTypesData: AudienceSplashModalSelectorData;
	currentPage: string;
	setCountryListData: React.Dispatch<React.SetStateAction<CountryListDataProps | null>>;
	setAudienceSelectionData: React.Dispatch<React.SetStateAction<AudienceSelectionProps | null>>;
	setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
	setModalJustOpened: React.Dispatch<React.SetStateAction<boolean>>;
	setStep: React.Dispatch<React.SetStateAction<string>>;
};

const AudienceSelectorFromLinkEntry = ({
	audienceTypesData,
	currentPage,
	setCountryListData,
	setAudienceSelectionData,
	setIsModalOpen,
	setModalJustOpened,
	setStep
}: AudienceSelectorFromLinkEntryProps) => {
	const handleAudienceSelection = async (
		event: React.MouseEvent | React.KeyboardEvent,
		item: { audienceTypeId: string }
	): Promise<void> => {
		if (eventMisfired(event)) return;
		await getAudienceSelection(
			event,
			item,
			true,
			audienceTypesData,
			setAudienceSelectionData,
			currentPage
		);
		setStep(
			item.audienceTypeId === individualGUID
				? audienceSortStepNames.initialStep
				: audienceSortStepNames.financialProfessionalAffirmation
		);
	};

	const handleAudienceSelectionButton = async (
		event: React.MouseEvent | React.KeyboardEvent,
		item: { audienceTypeId: string }
	) => {
		if (eventMisfired(event)) return;
		await handleAudienceSelection(event, item);

		if (item.audienceTypeId === individualGUID) {
			return setIsModalOpen(false);
		}
		if (setModalJustOpened) setModalJustOpened(false);
	};

	const handleCountrySwitch = async (
		event: React.MouseEvent | React.KeyboardEvent
	): Promise<void> => {
		if (eventMisfired(event)) return;
		await changeCountry(event, audienceTypesData, setCountryListData, true);
		if (setModalJustOpened) setModalJustOpened(false);
		setStep(audienceSortStepNames.countrySelection);
	};

	const sectionAudienceTypeEventHandler = async (
		event: React.MouseEvent | React.KeyboardEvent,
		item: SectionAudienceType
	): Promise<void> => {
		if (eventMisfired(event)) return;
		handleAudienceSelectionButton(event, item);
	};

	return (
		<div>
			<div className="audience-selector-from-link-header tc-white t-heading-xl-italic">
				{sanitizeHtml(audienceTypesData.greeting)}
			</div>
			<div className="audience-selector-from-link-content">
				<div className="audience-selector-from-link-desc t-body-sm">
					{audienceTypesData.introduction}
				</div>
				<AudienceSelectorList
					currentPage={currentPage}
					audienceTypes={audienceTypesData.sectionAudienceType}
					eventHandler={sectionAudienceTypeEventHandler}
				/>
				<div className="audience-selector-from-link-divider" />
				<LocationChangeCTA
					countryName={audienceTypesData.countryName}
					locationChangeText={audienceTypesData.locationChangeText}
					eventHandler={handleCountrySwitch}
					forceHandlerOnKeyUp={true}
				/>
			</div>
		</div>
	);
};

export default AudienceSelectorFromLinkEntry;
